import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Batches from "../batches/Batches";
import ProductTab from "./ProductTab";
import Brands from "../brands/Brands";
import Category from "../category/Category";
import Purchases from "../purchases/Purchases";
import PricingCatalog from "../../pricing-catalog/PricingCatalog";

export default function Products({ activeLabel = "products", setActiveLabel = () => {} }) {
  const location = useLocation();

  // Handle navigation from product detail page
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveLabel(location.state.activeTab);
    }
  }, [location.state, setActiveLabel]);

  // keep the logic here minimal — ProductTab contains the product list logic
  return (
    <>
      {activeLabel === "products" && <ProductTab />}
      {activeLabel === "batches" && <Batches />}
      {activeLabel === "brands" && <Brands />}
      {activeLabel === "categories" && <Category />}
      {activeLabel === "purchases" && <Purchases />}
      {activeLabel === "pricing-catalog" && <PricingCatalog />}
    </>
  );
}
